'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Constants


var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _timeUtil = require('../../utils/timeUtil');

var _httpConstants = require('../../utils/http/httpConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_MEDIA_SERVER_HTTP_CONFIG = {
    method: _httpConstants.METHODS.GET,
    timeout: 2 * _timeUtil.TIMES.SECOND,
    responseType: 'json'
};

exports.default = function (apiUrl, jwtToken) {
    return function (httpConfig) {
        var axiosConfig = _extends({}, DEFAULT_MEDIA_SERVER_HTTP_CONFIG, httpConfig);

        if (jwtToken) {
            axiosConfig.headers = _extends({}, axiosConfig.headers, {
                Authorization: 'Bearer ' + jwtToken
            });
        }

        axiosConfig.url = apiUrl + '/' + httpConfig.url;

        return (0, _axios2.default)(axiosConfig);
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/common/media/mediaService/createMediaHttpService.js
// module id = 2283
// module chunks = 0